import TabNavigationView from './TabNavigationView';

export default TabNavigationView;
